import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';
import EventRepeatRoundedIcon from '@mui/icons-material/EventRepeatRounded';
import LunchDiningRoundedIcon from '@mui/icons-material/LunchDiningRounded';
import EventRoundedIcon from '@mui/icons-material/EventRounded';
import RoomRoundedIcon from '@mui/icons-material/RoomRounded';

const items = [
  {
    icon: <ScheduleRoundedIcon />,
    title: 'Meeting Times',
    schedule: [
      {
        icon: <EventRepeatRoundedIcon fontSize="small" />,
        days: 'Monday, Wednesday, Friday',
        time: '1:50 PM – 3:30 PM',
      },
      {
        icon: <LunchDiningRoundedIcon fontSize="small" />,
        days: 'Every day',
        time: 'During lunch',
      },
      {
        icon: <RoomRoundedIcon fontSize="small" />,
        days: 'Location',
        time: 'Room 113/114',
      },
    ],
  },
  {
    icon: <LocationOnRoundedIcon />,
    title: 'Competition Dates and Locations',
    schedule: [
      {
        icon: <EventRoundedIcon fontSize="small" />,
        days: 'Aerocoast 1 — October 24th',
        time: 'Panama City Beach, Rutherford',
      },
      {
        icon: <EventRoundedIcon fontSize="small" />,
        days: 'Aerocoast 2 — November 7th',
        time: 'Tallahassee, Challenger Center',
      },
      {
        icon: <EventRoundedIcon fontSize="small" />,
        days: 'Aerocoast 3 — January 9th',
        time: 'Tallahassee, Challenger Center',
      },
      {
        icon: <EventRoundedIcon fontSize="small" />,
        days: 'Championship — January 30th',
        time: 'Fort Walton Beach, Rigdon Center',
      },
    ],
  },
  {
    icon: <EmojiEventsRoundedIcon />,
    title: 'Playoffs',
    description:
      'The team competes at various venues across our league against and with the same group of around 25 robots. At the league championship, there is a playoff bracket which, based on our performance, may result in us advancing to the Florida State Championship, likely in Orlando, and from there to Worlds in Houston. Specific details for those events will be provided when necessary.',
  }
];

export default function Highlights() {
  return (
    <Box
      id="highlights"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        color: 'white',
        bgcolor: 'grey.900',
      }}
    >
      <Container
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: '100%', md: '60%' },
            textAlign: { sm: 'left', md: 'center' },
          }}
        >
          <Typography component="h2" variant="h4" gutterBottom>
            Meetings
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {items.map((item, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <Stack
                direction="column"
                component={Card}
                spacing={1}
                useFlexGap
                sx={{
                  color: 'inherit',
                  p: 3,
                  height: '100%',
                  borderColor: 'hsla(220, 25%, 25%, 0.3)',
                  backgroundColor: 'grey.800',
                }}
              >
                <Box sx={{ opacity: '50%' }}>{item.icon}</Box>
                <div>
                  <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
                    {item.title}
                  </Typography>
                  {item.schedule ? (
                    <Stack spacing={1.5} sx={{ mt: 1 }}>
                      {item.schedule.map((slot, slotIndex) => (
                        <Stack
                          key={slotIndex}
                          direction="row"
                          spacing={1.5}
                          alignItems="center"
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: 32,
                              height: 32,
                              borderRadius: '50%',
                              flexShrink: 0,
                              color: 'primary.light',
                              backgroundColor: 'hsla(220, 25%, 25%, 0.4)',
                            }}
                          >
                            {slot.icon}
                          </Box>
                          <div>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: 'medium', color: 'grey.100' }}
                            >
                              {slot.days}
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'grey.400' }}>
                              {slot.time}
                            </Typography>
                          </div>
                        </Stack>
                      ))}
                    </Stack>
                  ) : (
                    <Typography variant="body2" sx={{ color: 'grey.400' }}>
                      {item.description}
                    </Typography>
                  )}
                </div>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
